module.exports = __webpack_public_path__ + "static/img/cadillac_6.db9ed51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ios-bluetooth/cadillac_6.png
// module id = KleJ
// module chunks = 215